import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { defineComponent, onMounted, onUnmounted, onBeforeUnmount, onDeactivated, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScreenStore, useMainStore, useSnapshotStore, useSlidesStore } from '@/store'
import { LOCALSTORAGE_KEY_DISCARDED_DB } from '@/configs/storage'
import { deleteDiscardedDB, lastTimeData } from '@/utils/database'
import { isPC } from './utils/common'
import useSlideHandler from '@/hooks/useSlideHandler'
import emitter, { EmitterEvents, RichTextAction } from '@/utils/emitter'
import { decrypt, encrypt } from '@/utils/crypto'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useExport from '@/hooks/useExport'

import Editor from './views/Editor/index.vue'
import Screen from './views/Screen/index.vue'
import Mobile from './views/Mobile.vue'
import { message } from 'ant-design-vue'
import { set } from 'lodash'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainStore = useMainStore()
const snapshotStore = useSnapshotStore()
const slidesStore = useSlidesStore()
const { databaseId, handleElement, handleElementId, editorAreaFocus } = storeToRefs(mainStore)
const { screening } = storeToRefs(useScreenStore())
const { slides } = storeToRefs(slidesStore)
const { addHistorySnapshot, delAll } = useHistorySnapshot()
const {
  createSlideByTemplate,
  resetSlides,
} = useSlideHandler()
if (process.env.NODE_ENV === 'production') {
  window.onbeforeunload = () => false
}
const { exportPPTX } = useExport()

// 定义一个响应式引用来存储查询参数
const queryParams = ref<Record<string, string>>({})


// 父窗口传递的数据值
const fatherMessage = ref<any>(null)
// 接收子窗口传递的数据
const receiveMessage = async (event: MessageEvent) => {
  // 验证来源，增加安全性
  // console.log('ORIGIN', window.Glob.VUE_APP_ORIGIN)
  // if (event.origin !== 'http://localhost:8082' && event.origin !== window.Glob.VUE_APP_ORIGIN) {
  if (!window.Glob.VUE_APP_ORIGIN.some((o: string) => o === event.origin)) {
    return
  }


  fatherMessage.value = event.data
  await setReceivedData()
  // resolveReceivedData()
}
// 初始化数据
const setReceivedData = async () => {
  // debugger
  const messageF = fatherMessage.value
  if (messageF) {
    // 解密数据
    const decryptedMessage = decrypt(messageF)
    const data = JSON.parse(decryptedMessage)
    // console.log('slidedata', data)
    // if (data.msgType && data.msgType === 'createPPTNow') {
    //   // debugger
    //   await resetSlides()
    // }

    // 将gpt传入的数据插入ppt
    if (data.msgType && data.msgType === 'slide') {
      // console.log('slide')
      // console.log('PPT插入顺序:', data.pptData.IndexNo)
      // console.log('PPT插入数据:', data.pptData.slideMsg)
      // debugger
      // 插入第一页清空原有数据
      if (data.pptData.IndexNo === 1) {
        // console.log('重置数据')
        // 重置幻灯片编号
        slidesStore.updateSlideIndex(0)
        slidesStore.setSlides([data.pptData.slideMsg])
        // console.log('重置数据end')
      }
      else if (data.pptData.IndexNo === -1) {
        // console.log('重置数据-1')
        // 清空所有数据
        await resetSlides()
        // 加载生成记录
        // 重置幻灯片编号
        slidesStore.updateSlideIndex(0)
        await slidesStore.setSlides(data.pptData.slideMsg)
        // 保存历史记录
        addHistorySnapshot()
      }
      else {
        // console.log('新建建据')
        createSlideByTemplate(data.pptData.slideMsg)
      }    
      slidesStore.setSlidesEnd(data.isComplete)
    }
    else if (data.msgType && data.msgType === 'text') {
      const canDo = await checkElement('text|shape', handleElementId.value, handleElement?.value?.type || '')
      if (!canDo) return
      const value = data.textMsg
      // console.log('textvalue:', value)
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'insert', value } })
      // addHistorySnapshot()
      setTimeout(() => {
        message.success('操作成功')
      }, 500)
    }
    else if (data.msgType && data.msgType === 'image') {
      // console.log('texthandleElement:', handleElement?.value?.type)
      const canDo = await checkElement('image', handleElementId.value, handleElement?.value?.type || '')
      if (!canDo) return
      // console.log('image')
      // 替换图片
      slidesStore.updateElement({
        id: handleElementId.value, 
        props: { src: data.imgMsg },
      })
      addHistorySnapshot()
      message.success('操作成功')
    }
    else if (data.msgType && data.msgType === 'needSelectText') {     
      const canDo = await checkElement('text|shape', handleElementId.value, handleElement?.value?.type || '')
      if (!canDo) return

      // 获取选中文本
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'AIClicked', value: 'GiveSelectText' } })
    }
    else if (data.msgType && data.msgType === 'over') {
      slidesStore.updateSlideIndex(0)
      saveGenerate()
    }
    else if (data.msgType && data.msgType === 'ppttitle') {     
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'SETTITLE', value: data.title } })      
    }
    else if (data.msgType && data.msgType === 'exportPPTX') {
      // console.log('exportPPTX:', slides.value)
      exportPPTX(slides.value, true)
    }
    else if (data.msgType && data.msgType === 'clearPPTX') { 
      await resetSlides()      
      slidesStore.updateSlideIndex(0)   
      delAll()  
    }
  }
}

// 清除

// 验证是否选中元素
const checkElement = async (element: string, handleValue: string, handleText: string) => {
  let canDo = true
  if (!handleValue) {
    // 发送消息给主页面提示
    await window.parent.postMessage({ action: 'ElementNull', text: '未选中PPT内元素'}, '*')
    canDo = false
  }
  else if (element.indexOf(handleText?.toLowerCase()) === -1) {
    // 发送消息给主页面提示
    await window.parent.postMessage({ action: 'ElementNull', text: '选中元素不符合应用格式'}, '*')
    canDo = false
  }
  return canDo
}
// 保存记录到数据库
const saveGenerate = async () => {
  // ppt导出页不需要做保存操作
  if (queryParams.value?.type === 'edit') {
    // 返回生成的json数据
    const generateAll = slides.value
    if (generateAll.length > 0) {
      const generateData = JSON.stringify(generateAll)
      // 加密
      const encryptedData = encrypt(generateData)
      // console.log('触发保存:')
      // debugger
      // 发送消息给主页面
      await window.parent.postMessage({ action: 'GenerateData', text: encryptedData }, '*')
    }
  }
}

// 提取查询参数
const extractQueryParams = () => {
  const params = new URLSearchParams(window.location.search)
  const result: Record<string, string> = {}
  params.forEach((value, key) => {
    result[key] = value
  })
  queryParams.value = result
}

onMounted(async () => {
  await extractQueryParams()
  window.addEventListener('message', receiveMessage)

  // console.log('routeType:', route.params)
  let delDB = ''
  // 初始化快照数据库 获取上次操作的最后一条数据1
  const lastData = await lastTimeData()
  // 恢复到指定数据
  if (lastData.data && lastData?.data.length > 0) slidesStore.setSlides(lastData.data[0].slides)
  delDB = lastData.data
  await deleteDiscardedDB(delDB)
  snapshotStore.initSnapshotDatabase()
  mainStore.setAvailableFonts()
})

// 移除监听
onBeforeUnmount(() => {
  window.removeEventListener('message', receiveMessage)
})

window.addEventListener('beforeunload', (e) => {
  // 设置警告消息
  const confirmationMessage = '你所做的更改可能未保存。';
  // 兼容不同浏览器的处理方式
  (e || window.event).returnValue = confirmationMessage // Gecko + IE
  return confirmationMessage // Webkit, Safari, Chrome 等
})

// 应用注销时向 localStorage 中记录下本次 indexedDB 的数据库ID，用于之后清除数据库
window.addEventListener('unload', () => {
  // ppt导出页不需要做保存操作
  if (queryParams.value?.type === 'edit') {
    // 保存历史记录
    addHistorySnapshot()
    saveGenerate()

    const discardedDB = localStorage.getItem(LOCALSTORAGE_KEY_DISCARDED_DB)
    const discardedDBList: string[] = discardedDB ? JSON.parse(discardedDB) : []
    discardedDBList.push(databaseId.value)
    // const newDiscardedDB = JSON.stringify(discardedDBList)
  }
})


return (_ctx: any,_cache: any) => {
  return (_unref(screening))
    ? (_openBlock(), _createBlock(Screen, { key: 0 }))
    : (_unref(isPC))
      ? (_openBlock(), _createBlock(Editor, { key: 1 }))
      : (_openBlock(), _createBlock(Mobile, { key: 2 }))
}
}

})